var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('img',{staticClass:"d-block",style:({
    height: '15px',
  }),attrs:{"alt":_vm.countryCode,"src":_vm.imageUrl}})
}
var staticRenderFns = []

export { render, staticRenderFns }